//PAQUETERIAS
//ESTILOS
import "../../components_cfdi/estilo.css";
import "../../components_cfdi/modal.css";
import SALES_DEBTS from "./sales_debts";
//IMAGENES/ICONOS

const PAID = (props) => {

  return (
    <SALES_DEBTS status={1}></SALES_DEBTS>
  );
};

export default PAID;
